/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthorizationStatus,
  RedAppWhiteListRequest,
  Status,
} from '../models';
import {
    AuthorizationStatusFromJSON,
    AuthorizationStatusToJSON,
    RedAppWhiteListRequestFromJSON,
    RedAppWhiteListRequestToJSON,
    StatusFromJSON,
    StatusToJSON,
} from '../models';

export interface AddRedAppToWhiteListRequest {
    redAppWhiteListRequest: RedAppWhiteListRequest;
    authorization?: string;
    onBehalfOf?: string;
}

export interface DeleteRedAppFromWhiteListRequest {
    redAppId: string;
    authorization?: string;
    onBehalfOf?: string;
}

/**
 * 
 */
export class RedAppsWhiteListApi extends runtime.BaseAPI {

    /**
     * Add red app to white list
     */
    async addRedAppToWhiteListRaw(requestParameters: AddRedAppToWhiteListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Status>> {
        if (requestParameters.redAppWhiteListRequest === null || requestParameters.redAppWhiteListRequest === undefined) {
            throw new runtime.RequiredError('redAppWhiteListRequest','Required parameter requestParameters.redAppWhiteListRequest was null or undefined when calling addRedAppToWhiteList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/redAppsWhiteList`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RedAppWhiteListRequestToJSON(requestParameters.redAppWhiteListRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
    }

    /**
     * Add red app to white list
     */
    async addRedAppToWhiteList(requestParameters: AddRedAppToWhiteListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Status> {
        const response = await this.addRedAppToWhiteListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete Red app id from white list.
     */
    async deleteRedAppFromWhiteListRaw(requestParameters: DeleteRedAppFromWhiteListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Status>> {
        if (requestParameters.redAppId === null || requestParameters.redAppId === undefined) {
            throw new runtime.RequiredError('redAppId','Required parameter requestParameters.redAppId was null or undefined when calling deleteRedAppFromWhiteList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/redAppsWhiteList/{redAppId}`.replace(`{${"redAppId"}}`, encodeURIComponent(String(requestParameters.redAppId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
    }

    /**
     * Delete Red app id from white list.
     */
    async deleteRedAppFromWhiteList(requestParameters: DeleteRedAppFromWhiteListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Status> {
        const response = await this.deleteRedAppFromWhiteListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
